import _ from 'lodash';
import React, { Component, createRef } from 'react'
import { Container, Grid, Segment, Icon, Checkbox, Dimmer, Loader, Header, Message } from 'semantic-ui-react'
import { sellerAcceptingJobsUpdate} from '../../services/Seller';
import './Preferences.less'
import { connect } from 'react-redux';

const initialState = { 
    message: '', 
    saving: false, 
    messageType: '',
    acceptingJobs: false
};

let messageDisplayTimeOut = undefined;

class Preferences extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
        this.googleMapRef = createRef();
    }

    async componentDidMount(){
        if(this.props.currentUser && this.props.currentUser.Seller)
        {
            this.setState({acceptingJobs : this.props.currentUser.Seller.acceptingJobs})
        }
    }

    componentDidUpdate(prevProps)
    {
        if(this.props.currentUser && this.props.currentUser.Seller
            && this.props.currentUser.Seller.acceptingJobs != prevProps.currentUser.Seller.acceptingJobs)
        {
            this.setState({acceptingJobs : this.props.currentUser.Seller.acceptingJobs})
        }
    }

    
    onAcceptingJobChange = async (e, data) => {  
        this.setState({saving:true, message:""})
        let currentValue = data.checked;
        let sellerID = this.props.currentUser.Seller.sellerID;
        if(sellerID)
        {
            let res = await sellerAcceptingJobsUpdate(sellerID,currentValue);
        
            if(res && res.resStatus == 200)
            {
                this.setState({saving:false, 
                    message:"Accepting jobs setting saved." , 
                    messageType:"success",
                    acceptingJobs: currentValue})
            }else
            {
                this.setState({saving:false, message:res.message , messageType:"success"})
            }
        }else
        {
            this.setState({saving:false, message:"In-valid user." , messageType:"error"})
        }

        if(messageDisplayTimeOut)
        {
            clearTimeout(messageDisplayTimeOut)
        }

        messageDisplayTimeOut = setTimeout(() => {
            this.setState({saving:false, message:"" })
        }, 1000);
    }

    render() {
        return (
            <>
                <Container fluid className="preferences-container" key="preferences-container">
                    <Segment.Group key="preferences-container-segment-group">
                        <Segment size="massive" className="no-radius" key="preferences-container-segment">
                            <Header as="h1" key="preferences-container-header">
                                <Header.Content key="preferences-container-header-content">
                                    <Icon name='setting' size='small' key="preferences-container-header-icon" />
                                    Preferences
                                </Header.Content>
                            </Header>
                        </Segment>
                    </Segment.Group>
                    <Segment padded basic key="preferences-content" className="preferences-content">
                        <Message hidden={this.state.message.length == 0} {
                            ...{
                                error: this.state.messageType == 'error',
                                success: this.state.messageType == 'success'
                            }
                        }>
                            {this.state.message}
                        </Message>
                        <Dimmer.Dimmable as={Grid} padded blurring>
                            <Dimmer active={this.state.saving}>
                                <Loader>Loading</Loader>
                            </Dimmer>
                            {
                                    <Grid.Row key={`preferences-row`}>
                                        <Grid.Column style={{width: 'auto'}} key={`preferences-column`} className="preference-column  accepting-job-text">
                                            {"Accepting Jobs"}
                                        </Grid.Column>
                                        <Grid.Column key={`preferences-column-value`} className="preference-column">
                                            {
                                            <Checkbox toggle 
                                                className='accepting-job-checkbox' 
                                                checked={this.state.acceptingJobs} 
                                                onChange={(e, data) => this.onAcceptingJobChange(e, data)} /> 
                                            }
                                        </Grid.Column>
                                    </Grid.Row>
                            }
                        </Dimmer.Dimmable>
                    </Segment>
                </Container>
            </>
        )
    }
}

const mapStateToProps = ({ auth: { currentUser } }) => {
    return { currentUser };
}

export default connect(mapStateToProps, null)(Preferences)

